import React, { useState, useEffect } from 'react';
import { addDoc, collection, serverTimestamp } from "firebase/firestore";
import { auth, db } from '../firebase-config';
import { useNavigate } from "react-router-dom";

function CreatePost({ isAuth }) {
  const [title, setTitle] = useState("");
  const [postText, setPostText] = useState("");
  const [errorMessage, setErrorMessage] = useState("")

  const postsCollectionRef = collection(db, "posts");
  let navigate = useNavigate();

  useEffect(() => {
    if (!isAuth) {
      navigate("/login");
    }
  }, [isAuth, navigate]);

  const createPost = async ({ title, postText }) => {
    try {
    if (!title?.trim() || !postText?.trim()) {
        throw new Error("Title and content are required");
        return;
      }

      const user = auth.currentUser;

      await addDoc(postsCollectionRef, {
         title
        ,postText
        ,author: {
           id: auth.currentUser.uid
          ,name: auth.currentUser.displayName
          ,email: auth.currentUser.email
        }
        ,createdAt: serverTimestamp()    
      });

      setErrorMessage(""); // clear error if successful
      navigate("/", { state: { successMessage: "Post created successfully!"}});
    } catch (err) {
      setErrorMessage("Something went wrong while creating the post.")
      console.error(err);
    };
}

  return (
    <div className='createPostPage'> 
      <div className='cpContainer'>
        <h1>Create a Post</h1>
        <div className="inputGP">
          <label>Title:</label>
          <input
            placeholder="Title..."
            value={title}
            onChange={(event) => {
              setTitle(event.target.value)
            }}
          />
        </div>
        <div className="inputGp">
          <label>Post:</label>
          <textarea 
            placeholder="Post..."
            value={postText}
            onChange={(event) => {
              setPostText(event.target.value)
            }} 
          />
        </div>

        {errorMessage && <p style={{ color: "red" }}>{errorMessage}</p>}

        <button onClick={() => createPost({ title, postText })}>
          Submit Post
        </button>
      </div>
    </div>
  )
}

export default CreatePost